import { render } from "./VerifyOtp.vue?vue&type=template&id=4f63b8ff"
import script from "./VerifyOtp.vue?vue&type=script&lang=js"
export * from "./VerifyOtp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__